import { randomNumber } from '../../../../utilities'
import { ImmobilizationConstants } from './immobilization.constants'
import { IImmobilizationAction, IImmobilizationState } from './immobilization.types'

export const initialImmobilizationState: IImmobilizationState = {
  option: null,
  devicesUsed: [],
  assessment: [],
  site: [],
  assessedBy: null,
  procedureComplications: [],
  response: null,
  responsePNNV: null,
  authorization: null,
  comments: '',
  addToTimeline: false,
  updateInputRows: false,
  key: randomNumber().toString(),
  date: '',
  time: '',
  successfulAttempt: true,
  pta: false,
  attempts: '1',
  type: 'Immobilization',
  size: '',
  rolePerforming: null,
  rolePerformingPNNV: null,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
  isEkgImport: null,
  nemsisCode: null,
}

export function immobilizationReducer(
  state: IImmobilizationState = initialImmobilizationState,
  action: IImmobilizationAction
): IImmobilizationState {
  switch (action.type) {
    case ImmobilizationConstants.SET_OPTION:
      return { ...state, option: action.option }
    case ImmobilizationConstants.SET_DEVICES_USED:
      return { ...state, devicesUsed: action.devicesUsed }
    case ImmobilizationConstants.SET_ASSESSMENT:
      return { ...state, assessment: action.assessment }
    case ImmobilizationConstants.SET_SITE:
      return { ...state, site: action.site }
    case ImmobilizationConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case ImmobilizationConstants.SET_DATE:
      return { ...state, date: action.date }
    case ImmobilizationConstants.SET_TIME:
      return { ...state, time: action.time }
    case ImmobilizationConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case ImmobilizationConstants.SET_SUCCESSFUL_ATTEMPT:
      return { ...state, successfulAttempt: action.successfulAttempt }
    case ImmobilizationConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case ImmobilizationConstants.SET_PROCEDURE_COMPLICATIONS:
      return { ...state, procedureComplications: action.procedureComplications }
    case ImmobilizationConstants.SET_RESPONSE:
      return { ...state, response: action.response }
    case ImmobilizationConstants.SET_RESPONSE_PNNV:
      return { ...state, responsePNNV: action.responsePNNV }
    case ImmobilizationConstants.SET_AUTHORIZATION:
      return { ...state, authorization: action.authorization }
    case ImmobilizationConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case ImmobilizationConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case ImmobilizationConstants.SET_UPDATE_INPUT_ROWS:
      return { ...state, updateInputRows: action.updateInputRows }
    case ImmobilizationConstants.SET_STATE:
      return { ...action.immobilizationState, updateInputRows: true }
    case ImmobilizationConstants.SET_ATTEMPTS:
      return { ...state, attempts: action.attempts }
    case ImmobilizationConstants.SET_SIZE:
      return { ...state, size: action.size }
    case ImmobilizationConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case ImmobilizationConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case ImmobilizationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case ImmobilizationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case ImmobilizationConstants.RESET_STATE:
      return {
        option: null,
        devicesUsed: [],
        assessment: [],
        site: [],
        assessedBy: null,
        procedureComplications: [],
        response: null,
        responsePNNV: null,
        authorization: null,
        comments: '',
        addToTimeline: false,
        updateInputRows: true,
        key: randomNumber().toString(),
        date: '',
        time: '',
        successfulAttempt: true,
        pta: false,
        attempts: '1',
        type: 'Immobilization',
        size: '',
        rolePerforming: null,
        rolePerformingPNNV: null,
        procedurePerformedByAnotherUnit: null,
        procedurePerformedByAnotherUnitPNNV: null,
        isEkgImport: null,
        nemsisCode: null,
      }
    default:
      return state
  }
}
